module.exports = __webpack_public_path__ + "static/project5-f93b39b85ea74abd0be12720af53892e.jpg";